import $ from "jquery";
import * as Common from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./callBackFunctions";

export default function standart() {}

export const fillDetail = (data) => {
  $("#area-naam").html(window.$catalog_area_selectedRow.naam);
  $("#area-naam-tooltip").html(window.$catalog_area_selectedRow.naam);
  $("#area-code").html(window.$catalog_area_selectedRow.code);
  $("#area-omschrijving").html(window.$catalog_area_selectedRow.omschrijving);
  $("#area-discipline-naam").html(
    window.$catalog_area_selectedRow.disciplineNaam
  );
  if (window.$catalog_area_selectedRow.isActive)
    $("#area-active").attr("checked", "checked");
  else $("#area-active").removeAttr("checked");

  //editSide
  $("#e-area-naam").val(window.$catalog_area_selectedRow.naam);
  $("#e-area-code").val(window.$catalog_area_selectedRow.code);
  $("#e-area-omschrijving").val(window.$catalog_area_selectedRow.omschrijving);

  if (window.$catalog_area_selectedRow.isActive)
    $("#e-area-active").attr("checked", "checked");
  else $("#e-area-active").removeAttr("checked");
  $("#area-identification").val(
    window.$catalog_area_selectedRow.identification
  );
};

export function GetRowOfDetail(row_id) {
  omnimap
    .GetRowOfDetailAction(row_id, window.$catalog_management_units_token)
    .then(fillDetail);
}

export const rowsHandleDelete = () => {
  window.$catalog_area_selectedIds.forEach((element) =>
    omnimap
      .Delete(element, window.$catalog_management_units_token)
      .then((result) => {
        $("#cover-spin").show(0);

        CallBackFunctions.RowsDeletedCallBack(
          window.$catalog_management_units_token
        );
      })
      .catch((error) => {
        console.log(error);
      })
  );
};
